export default () => ({
    homes: [],
    home: {
        title: '',
        image: '',
        description: '',
        phoneNumber: '',
        phoneLink: '',
        permalink: '#',
        sections: [

        ]
    },

    async init() {
        this.fetchServerData();
    },

    async selectHome(homeItem) {
        this.home = homeItem;
    },

    async fetchServerData() {
        try {

            const carehome = this.carehome;

            const response = await fetch(`/wp-json/custom/v1/homes?${new Date().getTime()}`);

            const data = await response.json();

            this.homes = data.homes.map((home, index) => ({
                id: index + 1,
                title: home.title,
                image:  home.imagemenu,
                description: home.description,
                link: home.permalink,
                location: home.location,
                phoneNumber: home.phone_number,
                phoneLink: home.phone_link,
                sections: home.sections
            }));

            //see if we are on a carehome page and then select that care home
            const matchingHomeIndex = this.homes.findIndex(home => home.title === this.carehome);

            if (matchingHomeIndex !== -1) {
                this.home = this.homes[matchingHomeIndex];
            } else {
                this.home = this.homes[0];
            }

        } catch (error) {
            console.error("Error fetching home data:", error);
        }
    }
});
